import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Warning } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
	deleteDialogTitle: {
		textAlign: 'center',
		color: theme.palette.error.main,
		fontWeight: 'bold',
	},
	deleteDialogContent: {
		textAlign: 'center',
	},
	deleteDialogIcon: {
		fontSize: 60,
		color: theme.palette.error.main,
		marginBottom: theme.spacing(2),
	},
	deleteButton: {
		backgroundColor: theme.palette.error.main,
		color: '#fff',
		'&:hover': {
			backgroundColor: theme.palette.error.dark,
		}
	}
}));

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
	const classes = useStyles();

	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
			maxWidth="xs"
			fullWidth
		>
			<DialogTitle id="confirm-dialog" className={classes.deleteDialogTitle} disableTypography>
				<Warning className={classes.deleteDialogIcon} />
				<Typography variant="h6" style={{ fontWeight: 'bold' }}>{title}</Typography>
			</DialogTitle>
			<DialogContent className={classes.deleteDialogContent}>
				<Typography component="div" variant="body1">
					{children}
				</Typography>
			</DialogContent>
			<DialogActions style={{ justifyContent: 'center', paddingBottom: 20 }}>
				<Button
					variant="outlined"
					onClick={() => onClose(false)}
					color="default"
				>
					{i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<Button
					variant="contained"
					onClick={() => {
						onClose(false);
						onConfirm();
					}}
					className={classes.deleteButton}
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
